var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-gallery"},[(_vm.videoId)?_c('main-video',{attrs:{"video-id":_vm.videoId}}):_vm._e(),_c('video-slider',{attrs:{"videos":_vm.videos}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }